import DocusaurusFooter from '../DocusaurusFooter'
import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import { requirements } from '../../docs-routes'

const Requirements = () =>
  <Paragraph>
    <Color variant='theme-description-text'>
      The Requirements page is where you can import your test requirements and track their status. When you add requirements to individual test case steps and then run the test cases in Live Run or in a Test Config, DAI updates your requirement status based on the results of those tests.
    </Color>
    <DocusaurusFooter path={requirements} />
  </Paragraph>

export default Requirements
